import { TrayType } from 'components/organisms/EditTrayModal/EditTrayModal.types'

export const DTM_MANUFACTURERS = [
  {
    label: 'Arthrex',
    value: 'arthrex',
  },
  {
    label: 'BIOMET SPINE',
    value: 'biomet-spine',
  },
  {
    label: 'DJO',
    value: 'djo',
  },
  {
    label: 'Globus',
    value: 'globus',
  },
  {
    label: 'KLS',
    value: 'kls',
  },
  {
    label: 'KYOCERA',
    value: 'kyocera',
  },
  {
    label: 'Medtronic',
    value: 'medtronic',
  },
  {
    label: 'MOBI-C',
    value: 'mobi-c',
  },
  {
    label: 'Paragon P28',
    value: 'paragon-p28',
  },
  {
    label: 'SKELETAL DYNAMICS',
    value: 'skeletal-dynamics',
  },
  {
    label: 'Smith & Nephew',
    value: 'smith-and-nephew',
  },
  {
    label: 'Stryker',
    value: 'stryker',
  },
  {
    label: 'Synthes',
    value: 'synthes',
  },
  {
    label: 'TITAN SPINE',
    value: 'titan-spine',
  },
  {
    label: 'Wright',
    value: 'wright',
  },
  {
    label: 'ZIMMER',
    value: 'zimmer',
  },
  {
    label: 'Zimmer Biomet',
    value: 'zimmer-biomet',
  },
] as const

export const COMMON_TRAY_TYPES: TrayType[] = ['custom implants']

const MANUFACTURER_SPECIFIC_TRAY_TYPES: Record<
  (typeof DTM_MANUFACTURERS)[number]['value'],
  TrayType[] | undefined
> = {
  arthrex: [
    'headless compression screw rack',
    'quickfix cannulated screw system',
  ],
  'biomet-spine': undefined,
  djo: undefined,
  kls: [
    'kls martin 1.5mm lindorf orthognathic module subtray 1',
    'kls martin 1.5mm lindorf orthognathic module subtray 2',
    'kls martin 2.0 micro module regular trauma pcoms',
    'kls martin 1.5mm micro module regular trauma pcoms',
  ],
  kyocera: undefined,
  medtronic: undefined,
  'mobi-c': undefined,
  'paragon-p28': ['2.0 mini monster', '2.5 mini monster', '3.0 mini monster'],
  'skeletal-dynamics': undefined,
  'smith-and-nephew': undefined,
  synthes: undefined,
  'titan-spine': undefined,
  wright: undefined,
  stryker: [
    'stryker screw caddy',
    'stryker upper face',
    'stryker middle face',
    'mini frag tray rack 4 main (plates)',
    'mini frag tray rack 4 top (plates)',
    'mini frag tray rack 2 top (plates)',
    'stryker 2.0 mp plates upper tray',
    'stryker 2.0 mp plates lower tray',
  ],
  globus: [
    'lumbar anchor set',
    'alif trial set',
    'hedron ia locking screws',
    '24x30mm spacers',
    '26x34mm spacers',
    '29x39mm spacers',
    'globus xtend cervical plate set',
    'globus xtend screw set',
  ],
  zimmer: [
    'zimmer curved rods',
    'zimmer adjustable transverse connector',
    'zimmer standard closure tops',
    'zimmer biomet vitality polyaxial screw caddy',
  ],
  'zimmer-biomet': [
    'zimmer curved rods',
    'zimmer adjustable transverse connector',
    'zimmer standard closure tops',
    'zimmer biomet vitality polyaxial screw caddy',
    'maxan anterior cervical plate system 1 level plates caddy',
    'maxan anterior cervical plate system 2 level plates caddy',
    'maxan anterior cervical plate system 3 level plates caddy',
    'maxan anterior cervical plate system screw caddy',
    'zimmer extra space test',
  ],
}

export const DTM_MANUFACTURERS_TRAY_TYPES: Record<
  (typeof DTM_MANUFACTURERS)[number]['value'],
  TrayType[]
> = Object.fromEntries(
  Object.entries(MANUFACTURER_SPECIFIC_TRAY_TYPES).map(([key, value]) => [
    key,
    value ? [...value, ...COMMON_TRAY_TYPES] : [...COMMON_TRAY_TYPES],
  ])
) as Record<(typeof DTM_MANUFACTURERS)[number]['value'], TrayType[]>

export const TRAY_PAR_LEVELS: Record<Exclude<TrayType, undefined>, number> = {
  'stryker screw caddy': 1,
  'stryker upper face': 1,
  'stryker middle face': 1,
  'zimmer curved rods': 2,
  'zimmer adjustable transverse connector': 1,
  'zimmer standard closure tops': 1,
  'zimmer biomet vitality polyaxial screw caddy': 1,
  '2.0 mini monster': 1,
  '2.5 mini monster': 1,
  '3.0 mini monster': 1,
  'headless compression screw rack': 1,
  'quickfix cannulated screw system': 1,
  'mini frag tray rack 4 main (plates)': 2,
  'mini frag tray rack 4 top (plates)': 2,
  'mini frag tray rack 2 top (plates)': 2,
  'custom implants': 1,
  instrument: 1,
  'maxan anterior cervical plate system 1 level plates caddy': 2,
  'maxan anterior cervical plate system 2 level plates caddy': 2,
  'maxan anterior cervical plate system 3 level plates caddy': 2,
  'maxan anterior cervical plate system screw caddy': 1,
  'zimmer extra space test': 1,
  'alif trial set': 2,
  'hedron ia locking screws': 1,
  '24x30mm spacers': 2,
  '26x34mm spacers': 2,
  '29x39mm spacers': 2,
  'lumbar anchor set': 1,
  'stryker 2.0 mp plates upper tray': 2,
  'stryker 2.0 mp plates lower tray': 2,
  'kls martin 1.5mm lindorf orthognathic module subtray 1': 2,
  'kls martin 1.5mm lindorf orthognathic module subtray 2': 2,
  'kls martin 1.5mm micro module regular trauma pcoms': 1,
  'kls martin 2.0 micro module regular trauma pcoms': 1,
  'globus xtend cervical plate set': 3,
  'globus xtend screw set': 1,
}
